import { useCartStore } from "../store/CartStore";
import { Transition } from "@headlessui/react";
import { Fragment, useContext } from "react";
import { cn, formatPriceToDkk } from "@/lib/utils";
import { useTrackingEvent } from "@/hooks/useTrackingEvent";
import Menu from "./v0/animated-menu";
import { LocationConfigurationContext } from "@/providers/LocationConfigurationProvider";
import { allMenusQueryOptions } from "@/hooks/useMenu";
import { useSuspenseQuery } from "@tanstack/react-query";
import { useRebate } from "@/hooks/useRebate";
//import { SearchButton } from "./SearchBar";

export const CartBar = ({
  setCartIsOpen,
  locationId,
}: {
  setCartIsOpen: (open: boolean) => void;
  locationId: string;
}) => {
  const { cart, price } = useCartStore();
  const tracking = useTrackingEvent();
  const { rebate } = useContext(LocationConfigurationContext);
  const menusQuery = useSuspenseQuery(allMenusQueryOptions(locationId));
  const { finalPrice } = useRebate(cart, menusQuery.data, rebate, price);

  return (
    <Transition
      show={true}
      appear={true}
      as={Fragment}
      enter="transition-all ease-in-out duration-300 delay-200"
      enterFrom="opacity-0 translate-y-full"
      enterTo="opacity-100 translate-y-0 translate-y-0"
      leave="transition-all duration-300"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div
        className={cn(
          "inset-x-0 fixed bottom-0 z-20",
          cart.length > 0
            ? "max-md:bg-muted md:before:hidden before:absolute before:bg-gradient-to-t before:from-muted  before:to-transparent before:bottom-[100%] before:left-0 before:w-full before:h-[75%] before:z-[9] before:pointer-events-none"
            : ""
        )}
      >
        <div
          className={cn(
            "px-4 pb-4 w-full flex justify-start items-center gap-4",
            cart.length > 0 ? "md:justify-end" : ""
          )}
        >
          <div className="text-foreground flex flex-row gap-4 rounded-md h-auto items-center justify-between cursor-pointer empty:hidden">
            <Menu showLabel={cart.length === 0} />
          </div>
          {cart.length === 0 ? null : (
            <button
              onClick={() => {
                try {
                  tracking.capture("cart_viewed", {
                    locationId: locationId,
                    value: price,
                  });
                } catch (error) {
                  console.error("Tracking error:", error);
                }

                setCartIsOpen(true);
              }}
              className="w-full md:w-1/2 lg:w-1/3 shadow-lg md:max-w-[400px]"
            >
              <div className="bg-primary flex flex-row rounded-md w-full h-auto items-center justify-between py-4 cursor-pointer text-primary-foreground px-4">
                <div className="flex flex-row gap-x-2 items-center">
                  <div className="bg-background size-6 flex items-center justify-center rounded-full aspect-square text-xs text-primary font-medium">
                    {cart.reduce((acc, item) => acc + item.count, 0)}
                  </div>
                  <span className="text-primary-foreground text-sm">
                    View order
                  </span>
                </div>
                <span className="text-sm">{formatPriceToDkk(finalPrice)}</span>
              </div>
            </button>
          )}
        </div>
      </div>
    </Transition>
  );
};
